import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import { getTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { getListViewTypeForFolder } from 'owa-mail-list-store';
export function getInboxTableView(focusedViewFilter) {
    var inboxFolderId = folderNameToId('inbox');
    var tableQuery = createMailFolderTableQuery(inboxFolderId, getListViewTypeForFolder(inboxFolderId), 'mail', focusedViewFilter);
    return getTableViewFromTableQuery(tableQuery);
}
//# sourceMappingURL=getInboxTableView.js.map